import { render, staticRenderFns } from "./SymbolItemDisplay.vue?vue&type=template&id=3c59ca7a&"
import script from "./SymbolItemDisplay.vue?vue&type=script&lang=ts&"
export * from "./SymbolItemDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./SymbolItemDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VTextField})
